import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';

@Component({
  selector: 'sgt-switch-input',
  templateUrl: './switch-input.component.html',
  styleUrls: ['./switch-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchInputComponent),
      multi: true
    }
  ]
})
export class SwitchInputComponent extends CustomControlValueAccessor<boolean> {
  @Input() label = '';

  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }
  get disabled(): boolean {
    return this._disabled;
  }

  protected updateValue(value: boolean | null): void {
    this._value = value ?? false;
  }

  onValueChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.emitChange(target.checked);
    this.markAsTouched();
  }

  get checked(): boolean {
    return this._value ?? false;
  }
}
